"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RatingSize;
(function (RatingSize) {
    RatingSize[RatingSize["Small"] = 0] = "Small";
    RatingSize[RatingSize["Large"] = 1] = "Large";
})(RatingSize = exports.RatingSize || (exports.RatingSize = {}));
//# sourceMappingURL=Rating.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Rating/Rating.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Rating/Rating.Props.js
// module chunks = 1